export const locale = {
    lang: 'zh1',
    data: {
      'EDITOR': {
        'ACERCADE': '（可選）在創建調查之前，您可以編輯調查的某些特徵，訪問調查後可以在調查中查看所做的更改',
        'CONCAMBIOS': '檢測到對測量配置的更改，您必須首先生成要應用的更改的測量，之後才能完成該步驟',
        'CARGANDO': '加載信息',
        'GUARDANDO': '保存更改',
        'CONFIGADICIONAL': {
          'TITULO': '附加配置',
          'SUBTITULO': '這些設置適用於所有語言的調查',
          'DISPONIBLES': '可用的控件',
          'SAVEOK': '配置已成功更新',
          'CONTROLES': {
            'PIN': '使用用戶PIN啟用調查保護',
            'RANDOM': '啟用隨機驗證問題',
            'LIDERES': '在陳述的觀點中顯示領導者的名字（CEO / Boss）'
          }
        },
        'ELEMENTOS': {
          'GUIA': '該塊的元素',
          'COLORES': {
            'ORIGINAL': '未修改的元素',
            'MODIFICADO': '修改元素'
          },
          'TOOLTIPS': {
            'ORIGINAL': '尚未修改任何元素',
            'MODIFICADO': '一個或多個元素已被修改',
            'COMPLETO': '所有元素均已修改'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': '沒有圖片',
              'ACTUAL': '當前圖像'
            },
            'TEXTO': {
              'INGRESAR': '輸入你的文字'
            }
          },
          'BOTONES': {
            'ENTRAR': '編輯調查特徵',
            'REGRESAR': '回去',
            'CONTINUAR': '繼續',
            'CANCELAR': '取消',
            'GUARDAR': '保存更改',
            'IMAGEN': '變更圖片',
            'EDITOR': '編輯訊息',
            'ELEMENTOS': '幫助',
            'ACTIVAR': '展示',
            'DESACTIVAR': '隱藏',
            'ACEPTAR': '接受',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': '登錄',
            'PASOS': {
              'LOGO': {
                'TITULO': '經紀人徽標',
                'ELEMENTOS': {
                  'logo': '您可以上傳圖片來更改經紀人的徽標'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': '先前的指示',
                'ELEMENTOS': {
                  'text': '您可以編寫說明以進入調查之前顯示'
                }
              },
              'LOGINFORM': {
                'TITULO': '登錄表格',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': '您可以更改“密碼”字段的提示文本',
                  'buttons_login_label': '您可以更改登錄按鈕的文本',
                  'recoveryAccessKey_text': '您可以更改按鈕文字以恢復密碼',
                }
              },
              'BACKGROUND': {
                'TITULO': '背景圖像',
                'ELEMENTOS': {
                  'backgroudImage': '您可以更改此屏幕上顯示的背景圖像',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': '通用元素',
            'PASOS': {
              'LOGO': {
                'TITULO': '經紀人徽標',
                'ELEMENTOS': {
                  'logo': '您可以上傳圖片來更改經紀人的徽標'
                }
              },
              'HEADER': {
                'TITULO': '標頭元素',
                'ELEMENTOS': {
                  'buttons_logout_label': '您可以更改登錄按鈕的文本',
                  'header_logo': '您可以更改系統徽標的圖像',
                  'isShowLastLogin_active': '您可以選擇顯示或隱藏上次訪問的日期',
                  'backgroundImage': '您可以更改此屏幕上顯示的背景圖像',
                  'header_showUserName': '您可以選擇顯示或隱藏用戶名'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': '歡迎畫面',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': '屏幕內容',
                'ELEMENTOS': {
                  'text': '您可以修改歡迎屏幕的內容',
                  'buttons_next_label': '您可以更改按鈕文字以繼續',
                }
              },
              'LOGOUT': {
                'TITULO': '登出時的訊息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按鈕文字以取消操作',
                  'buttons_logout_label': '您可以更改按鈕的文本以註銷',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': '指令畫面',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': '屏幕內容',
                'ELEMENTOS': {
                  'text': '您可以修改說明屏幕的內容',
                  'buttons_previous_label': '您可以更改按鈕文字以返回',
                  'buttons_start_label': '您可以更改按鈕文字以開始',
                  'buttons_continue_label': '您可以更改按鈕文字以繼續',
                }
              },
              'LOGOUT': {
                'TITULO': '登出時的訊息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按鈕文字以取消操作',
                  'buttons_logout_label': '您可以更改按鈕的文本以註銷',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': '調查驗收信息',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': '激活消息以接受或拒絕調查',
                'ELEMENTOS': {
                  'active': '激活啟動前消息'
                }
              },
              'CONTENIDO': {
                'TITULO': '留言內容',
                'ELEMENTOS': {
                  'header_title': '您可以更改消息標題',
                  'text': '您可以更改消息的內容',
                  'buttons_previous_label': '您可以更改按鈕文字以返回',
                  'buttons_acept_label': '您可以更改按鈕文字以拒絕調查',
                  'buttons_cancel_label': '您可以更改按鈕文字以接受調查'
                }
              },
              'LOGOUT': {
                'TITULO': '登出時的訊息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按鈕文字以取消操作',
                  'buttons_logout_label': '您可以更改按鈕的文本以註銷',
                }
              },
              'NOACEPT': {
                'TITULO': '拒絕調查時的提示',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以更改消息的文本',
                  'buttons_saveAndExit_label': '您可以更改按鈕文本以確認並退出',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': '調查畫面',
            'PASOS': {
              'NAV': {
                'TITULO': '導航按鈕',
                'ELEMENTOS': {
                  'buttons_next_label': '您可以更改按鈕文字以繼續',
                  'buttons_previous_label': '您可以更改按鈕文字以返回',
                  'buttons_finish_label': '您可以更改按鈕文字以結束調查',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': '指令側面板',
                'ELEMENTOS': {
                  'button_label': '您可以更改按鈕文本以顯示說明面板',
                  'active': '您可以選擇顯示或隱藏說明面板上的按鈕',
                  'text': '您可以修改說明屏幕的內容',
                }
              },
              'SOPORTE': {
                'TITULO': '支撐提示側面板',
                'ELEMENTOS': {
                  'button_label': '您可以更改按鈕文本以顯示支持提示面板',
                  'active': '您可以選擇顯示或隱藏支持提示面板按鈕',
                  'text': '您可以修改支持提示屏幕的內容',
                }
              },
              'COLUMNA1': {
                'TITULO': '陳述：觀點1',
                'ELEMENTOS': {
                  'title': '您可以更改透視圖1的列標題',
                  'tooltip_active': '您可以選擇顯示或隱藏列標題工具提示',
                  'tooltip_text': '您可以修改列標題工具提示的內容',
                }
              },
              'COLUMNA2': {
                'TITULO': '陳述：觀點2',
                'ELEMENTOS': {
                  'title': '您可以更改透視圖2的列標題',
                  'tooltip_active': '您可以選擇顯示或隱藏列標題工具提示',
                  'tooltip_text': '您可以修改列標題工具提示的內容',
                }
              },
              'FINISH_1': {
                'TITULO': '調查結束時的消息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'textAnswered': '您可以在回答所有問題時修改顯示的消息文本',
                  'textNotAnswered': '您可以通過不回答所有問題來修改顯示消息的文本',
                  'textFooter': '您可以修改消息文本',
                  'buttons_previous_label': '您可以更改按鈕文字以返回',
                  'buttons_close_label': '您可以更改按鈕文字以結束調查',
                }
              },
              'FINISH_2': {
                'TITULO': '完成調查後的消息',
                'ELEMENTOS': {
                  'windowFinishMessage_title': '您可以更改消息標題',
                  'windowFinishMessage_text': '您可以修改消息文本',
                  'windowRanking_active': '您可以選擇顯示或隱藏消息以對調查進行評分',
                  'windowRanking_text': '您可以修改消息文本以對調查進行評分',
                  'windowFinishMessage_buttons_close_label': '您可以更改按鈕文字以繼續',
                }
              },
              'LOGOUT_1': {
                'TITULO': '登出時的訊息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以修改消息文本',
                  'textBandRequired': '您可以修改不可逆警告消息的文本',
                  'buttons_previous_label': '您可以更改按鈕文字以取消操作',
                  'buttons_saveAndExit_label': '您可以更改按鈕文本以保存更改並註銷',
                }
              },
              'LOGOUT_2': {
                'TITULO': '登出後的訊息',
                'ELEMENTOS': {
                  'title': '您可以更改消息標題',
                  'text': '您可以修改消息文本',
                  'buttons_close_label': '您可以更改按鈕文字以繼續',
                }
              },
            }
          },
        }
      }
    }
};
